import { EDITOR_QUOTE_CLASS } from "@repo/ui/components/editor";
import { NodeViewWrapper } from "@tiptap/react";
import type { ReactNode } from "react";

export type SaveState =
  | { kind: "idle" }
  | { kind: "incomplete"; message: string }
  | { kind: "saving" }
  | { kind: "saved"; message: string }
  | { kind: "error"; message: string };

/**
 * The quote's bar, worn by the line a phrase sits on. It is the save indicator:
 * grey until the phrase's record is saved, primary once it is, red when the save failed.
 */
export type PhraseLineState = "pending" | "saved" | "failed";
const PHRASE_LINE_CLASS = `${EDITOR_QUOTE_CLASS} my-2 transition-colors`;
export const PHRASE_LINE_CLASSES: Readonly<Record<PhraseLineState, string>> = {
  pending: PHRASE_LINE_CLASS,
  saved: `${PHRASE_LINE_CLASS} border-l-primary`,
  failed: `${PHRASE_LINE_CLASS} border-l-destructive`,
};

/** A smart phrase's place in the note. Its bar, which also shows whether it is saved, belongs to its line (see PHRASE_LINE_CLASSES). */
export function PhraseBlock({ children }: { children: ReactNode }) {
  return (
    <NodeViewWrapper as="span">
      <span contentEditable={false}>{children}</span>
    </NodeViewWrapper>
  );
}
